import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * SoftRedirect — until Emergent supports path-level HTTP 301 redirects,
 * legacy alias URLs (e.g. /how-private-tyre-quotes-work) render this
 * component. It:
 *   1. Emits an explicit <meta robots="noindex, nofollow"> and
 *      <link rel="canonical" href="{target}"> before the SPA transitions,
 *      so the crawler prerender captures a strong signal on the alias URL.
 *   2. Performs a hard `location.replace` (not a client-side push) so the
 *      user's URL bar updates to the canonical and the alias never becomes
 *      part of the history stack.
 * When Emergent ships true 301 support, delete this component and add the
 * rules at the hosting layer.
 */
export default function SoftRedirect({ to }) {
  useEffect(() => {
    // Delay one tick so Helmet has flushed its tags into the prerendered
    // HTML before the browser navigates away.
    const t = setTimeout(() => {
      window.location.replace(to);
    }, 0);
    return () => clearTimeout(t);
  }, [to]);

  const absoluteCanonical = to.startsWith("http")
    ? to
    : `https://tyrematch.co.nz${to}`;

  return (
    <>
      <Helmet>
        <title>Redirecting… | TyreMatch</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={absoluteCanonical} />
        <meta httpEquiv="refresh" content={`0; url=${to}`} />
      </Helmet>
      <div style={{ padding: "40px", textAlign: "center", fontFamily: "system-ui" }}>
        <p>Redirecting to <a href={to}>{to}</a>…</p>
      </div>
    </>
  );
}
